import $ from 'jquery';

export default function contentMenu() {
  $('#doc-viewer h2').each(function (index) {
    $(this).attr('id', `title_${index}`);
  });

  $('.js-content-menu-list a').on('click', function (e) {
    e.preventDefault();

    const href = $(this).attr('href');

    $(this).closest('.js-content-menu-list').find('.is-active').removeClass('is-active');
    $(this).addClass('is-active');

    $('html, body').animate({
      scrollTop: $(href).offset().top - $('.js-header').height()
    }, 500);
  });

  $('.js-content-menu-btn').on('click', function (e) {
    e.preventDefault();

    $(this).toggleClass('is-active');
    $('.js-content-menu-list').slideToggle({
      duration: 400,
      start: function () {
        $(this).css('display', 'inline-block');
      },
    });
  });
}


// WEBPACK FOOTER //
// ./src/assets/js/project/content-menu.js